import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { getEtapas } from "../../controllers/org";
import { profileTypeLabels, profileTypes } from "../../controllers/profiles";

export default function ProductForm(props) {
  const [productName, setProductName] = useState(props.product_name || '');
  const [productDescription, setProductDescription] = useState(props.product_description || '');
  const [productType, setProductType] = useState(props.product_type || 'libro');
  const [price, setPrice] = useState(props.price || '');
  const [profileTypeId, setProfileTypeId] = useState(props.profile_type_id || '');
  const [etapaId, setEtapaId] = useState(props.etapa_id || '');
  const [active, setActive] = useState(props.active || false);
  const [stripeProductId, setStripeProductId] = useState(props.stripe_product_id || '');
  const [stripePriceId, setStripePriceId] = useState(props.stripe_price_id || '');
  const [etapas, setEtapas] = useState(props.etapas || []);
  const [weight, setWeight] = useState(props.weight || 1000);

  useEffect(() => {
      if (!props.etapas) {
        loadEtapas();
      }
  }, []);

  async function loadEtapas() {
    const etapas = await getEtapas();
    setEtapas(etapas);
  }

  function submit() {
    const productData = {
      product_id: props.product_id,
      product_name: productName,
      product_description: productDescription,
      product_type: productType,
      price: price,
      profile_type_id: profileTypeId,
      etapa_id: etapaId,
      active: active,
      stripe_product_id: stripeProductId,
      stripe_price_id: stripePriceId,
      weight: weight
    }
    if (typeof props.onSubmit === 'function') {
      props.onSubmit(productData);
    }
  }

  function cancel() {
    if (typeof props.cancel === 'function') {
      props.cancel();
    }
  }

  if (!etapas.length) {
    return <p>Cargando...</p>;
  }

  return <Card>
    <Card.Header>{props.product_id ? 'Editar producto' : 'Crear nuevo producto'}</Card.Header>
    <Card.Body>
      <Form onSubmit={(e) => {e.preventDefault(); submit()}}>
        <Container>
          <Row>
            <Col lg={4}>
              <Form.Group>
                <Form.Label htmlFor="productName">Nombre del producto</Form.Label>
                <Form.Control type="text" id="productName" value={productName} onChange={(e) => setProductName(e.target.value)} />
              </Form.Group>
              <Form.Group className="mt-4">
                <Form.Label htmlFor="productDescription">Descripción del producto</Form.Label>
                <Form.Control type="text" id="productDescription" value={productDescription} onChange={(e) => setProductDescription(e.target.value)} />
              </Form.Group>
            </Col>
            <Col lg={2}>
              <Form.Group>
                <Form.Label htmlFor="productType">Tipo de producto</Form.Label>
                <Form.Select id="productType" value={productType} onChange={(e) => setProductType(e.target.value)} disabled >
                  <option value="libro">Libro</option>
                  <option value="membresia">Membresía</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-4">
                <Form.Label htmlFor="productPrice">Precio del producto</Form.Label>
                <Form.Control type="number" id="productPrice" value={price} onChange={(e) => setPrice(e.target.value)} />
              </Form.Group>
            </Col>
            <Col lg={2}>
              <Form.Group>
                <Form.Label htmlFor="profileType">Tipo de perfil</Form.Label>
                <Form.Select id="profileType" value={profileTypeId} onChange={(e) => setProfileTypeId(e.target.value)}>
                  <option key={`profile-type-none`} value="none">Selecciona un tipo de perfil</option>
                  {Object.entries(profileTypeLabels).map(([id, label]) => (
                    <option key={`profile-type-${id}`} value={id}>{label}</option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-4">
                <Form.Label htmlFor="etapa">Etapa</Form.Label>
                <Form.Select id="etapa" value={etapaId} onChange={(e) => setEtapaId(e.target.value)}>
                  <option key={`etapa-none`} value="none">Selecciona una etapa</option>
                  {etapas.filter(etapa => etapa.type === parseInt(profileTypeId) || profileTypeId === 'none').map(et => (
                    <option key={`etapa-${et.etapa_id}`} value={et.etapa_id}>{et.title}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={2}>
              <Form.Group>
                <Form.Label htmlFor="active">Activo</Form.Label>
                <Form.Check type="checkbox" id="active" checked={active} onChange={(e) => setActive(e.target.checked)} />
              </Form.Group>
              <Form.Group>
                <Form.Label htmlFor="weight">Orden (Weight)</Form.Label>
                <Form.Control type="number" id="weight" value={weight} onChange={(e) => setWeight(e.target.value)} />
              </Form.Group>
            </Col>
            { props.product_id && 
              <Col lg={4}>
                <p>Stripe Product ID: {stripeProductId}</p>
                <p>Stripe Price ID: {stripePriceId}</p>
              </Col>
            }
          </Row>
        </Container>
      </Form>
    </Card.Body>
    <Card.Footer>
      <Row className="actions text-end">
        <Col lg={8}></Col>
        {typeof props.cancel === 'function' && <Col lg={2} xs={6}>
          <Button className="btn-secondary" onClick={cancel}>Cancelar</Button>
        </Col>}
        <Col lg={2} xs={6}>
          <Button className="btn-primary" onClick={submit}>Guardar</Button>
        </Col>
      </Row>
    </Card.Footer>
  </Card>

}